import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import mutations from './mutations'
import createMultiTabState from 'vuex-multi-tab-state'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {

  },
  plugins: [
    createPersistedState({
      'key': 'sale-app'
      // storage: {},
    }),
    createMultiTabState({
      statesPaths: [
        'isFullScreen',
        'workingStatusLastRequest',
        'openModalLogin',
        'authenticated',
        'user'
      ]
    })
  ],
  state: {
    workingStatusTimeOut: null,
    workingStatusLastRequest: null,
    lockQuestionScreen: false,
    openModalLogin: false,
    showLoadingScreen: false,
    authenticated: false,
    user: {},
    totalSizeUploaded: 0,
    maxSizeUpload: 0,
    alertMessage: {
      open: false,
      msg: '',
      type: 'error',
      title: ''
    },
    isFullScreen: false,



    dateFilterSave: -1,
    dateRangeBill: {
      fromDate: -1,
      toDate: -1
    },
    condenseDashboard: {
      conventional: false,
      rush: false,
      biologic: false
    },

  },
  mutations: mutations,
  actions: {},
  getters: {
    authenticated: state => {
      return state.authenticated
    },
    lockQuestionScreen: state => {
      return state.lockQuestionScreen
    },
    isFullScreen: state => {
      return state.isFullScreen
    },
    user: state => {
      return state.user
    },
    settingMode: state => {
      return (state.user) ? state.user.settingMode : 0
    },
    dateFilterSave: state => {
      return state.dateFilterSave
    },
  }
})
